import React, { Component, Fragment } from "react";
import { CONTRACT, DATE_FORMAT } from "consts";
import { formatDate } from "api";
//
import {
    withStyles,
    Typography,
    Button,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";

const styles = (theme) => ({
    dialog: {
        maxWidth: "660px",
        padding: theme.spacing(1),
    },
    content: {
        overflowY: "visible",
    },
});

class RangeAddDeleteConfirmation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deletionConfirmationOpened: false,
        };
    }

    getSelectedTasks(selectedEvents) {
        return selectedEvents
            .map((event) => event.task)
            .filter((value, index, self) => self.indexOf(value) === index);
    }

    getSelectedProjects(selectedEvents) {
        return selectedEvents
            .map((event) => event.project)
            .filter((value, index, self) => self.indexOf(value) === index);
    }

    render() {
        const {
            classes,
            contract,
            open,
            selectedEvents,
            selectedFrom,
            selectedTo,
            onClose,
            onAdd,
            onMarkPresence,
            onDelete,
        } = this.props;
        const { deletionConfirmationOpened } = this.state;

        const selectedProjects = this.getSelectedProjects(selectedEvents);
        const selectedTasks = this.getSelectedTasks(selectedEvents);

        return (
            <Fragment>
                <Dialog
                    maxWidth={false}
                    open={open && !deletionConfirmationOpened}
                    onClose={onClose}
                    PaperProps={{
                        className: classes.dialog,
                    }}
                >
                    <DialogTitle>Choose action</DialogTitle>
                    <DialogContent className={classes.content + " modalWindow"}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography>
                                    For selected range between{" "}
                                    <b>{selectedFrom && formatDate(selectedFrom)}</b> and{" "}
                                    <b>{selectedTo && selectedTo.format(DATE_FORMAT)}</b>
                                    {selectedEvents.length > 0 && (
                                        <Fragment>
                                            {" "}
                                            with <b>{selectedEvents.length}</b> entries
                                        </Fragment>
                                    )}
                                    , do you want to:
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                item
                                xs={12}
                                justifyContent="space-around"
                                spacing={1}
                            >
                                <Grid item>
                                    <Button
                                        color="primary"
                                        onClick={() => onAdd(selectedFrom, selectedTo, false).then(onClose)}
                                    >
                                        CREATE NEW ENTRIES
                                    </Button>
                                </Grid>
                                {contract === CONTRACT.UOP && false && (
                                    <Grid item>
                                        <Button
                                            disabled
                                            color="primary"
                                            onClick={() => onAdd(selectedFrom, selectedTo, true).then(onClose)}
                                        >
                                            CREATE OVERTIME ENTRIES
                                        </Button>
                                    </Grid>
                                )}
                                {contract !== CONTRACT.UOP && (
                                    <Grid item>
                                        <Button
                                            color="secondary"
                                            disabled={selectedEvents.length > 0}
                                            onClick={() => onMarkPresence(selectedFrom, selectedTo, selectedEvents.length > 0)
                                                .then(onClose)
                                            }
                                        >
                                            MARK PRESENCE
                                        </Button>
                                    </Grid>
                                )}
                                {selectedEvents.length > 0 && (
                                    <Grid item>
                                        <Button onClick={() => this.setState({ deletionConfirmationOpened: true })}>
                                            DELETE ALL ENTRIES
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item>
                                    <Button onClick={onClose}>CANCEL</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>

                <Dialog
                    maxWidth={false}
                    open={open && deletionConfirmationOpened}
                    onClose={() =>
                        this.setState({ deletionConfirmationOpened: false }, onClose)
                    }
                    PaperProps={{
                        className: classes.dialog,
                    }}
                >
                    <DialogTitle>Delete entries</DialogTitle>
                    <DialogContent className={classes.content}>
                        <Grid container>
                            <Grid container item xs={12} justifyContent="center">
                                <Grid item>
                                    <Typography align="center">
                                        Are you sure you want to delete{" "}
                                        <b>{selectedEvents.length}</b> entries
                                        <br />
                                        (from{" "}
                                        <span
                                            title={selectedProjects
                                                .map(
                                                    (project) => `${project.Key} - ${project.Name}`
                                                )
                                                .join(", ")}>
                                            <b>{selectedProjects.length}</b> different projects
                                        </span>{" "}
                                        and{" "}
                                        <span
                                            title={selectedTasks
                                                .map((task) => `${task.Name} - ${task.Summary}`)
                                                .join(", ")}>
                                            <b>{selectedTasks.length}</b> different tasks)
                                        </span>
                                        ?
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent="space-around" spacing={2}>
                            <Grid item>
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        onDelete(selectedEvents, selectedFrom, selectedTo)
                                            .then(() =>
                                                this.setState(
                                                    { deletionConfirmationOpened: false },
                                                    () => onClose(true)
                                                )
                                            );
                                    }}
                                >
                                    DELETE
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    onClick={() =>
                                        this.setState(
                                            { deletionConfirmationOpened: false },
                                            onClose
                                        )
                                    }
                                >
                                    CANCEL
                                </Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(RangeAddDeleteConfirmation);
